import { Box, Typography } from '@mui/material';
import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { authStates } from '../../../redux/authStates';
import { useAppSelector } from '../../../redux/store/configureStore';
import { paths } from '../../../routes/paths';
import ConfigureProfileForm from '../components/auth-configure-profile-form';

const ConfigureProfile = () => {
    const navigate = useNavigate();
    const authCurrentState = useAppSelector((state) => state.user.currentState);
    const isLoadingUser = useAppSelector((state) => state.user.isLoadingData);
    const isLoadingData = useAppSelector((state) => state.user.isLoadingData);

    useEffect(() => {
        if (isLoadingUser || isLoadingData || !window.location.pathname.includes(paths.CONFIGURE_PROFILE)) {
            return;
        }

        if (authCurrentState === authStates.FULLY_CONFIGURED) {
            navigate(paths.HOME);
            return;
        }

        if (authCurrentState === authStates.LOGGED_OUT) {
            navigate(paths.LOGIN);
            return;
        }
    }, [isLoadingUser, isLoadingData, authCurrentState]);

    return (
        <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '8px' }}>
                <Typography
                    component="h1"
                    sx={{
                        fontSize: '32px',
                        fontWeight: '600',
                        lineHeight: '40px',
                        textAlign: 'center',
                        textWrap: 'balance',
                    }}
                >
                    Let's set you up!
                </Typography>
                <Typography sx={{ textAlign: 'center', textWrap: 'balance' }}>
                    Introduce yourself to tailor your Zaplify experience
                </Typography>
            </Box>
            <ConfigureProfileForm />
        </>
    );
};

export default ConfigureProfile;
